var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CalculatorUser',{attrs:{"createData":_vm.createData,"calculator":_vm.calculator,"countries":_vm.countries,"countriesUK":_vm.countriesUK,"states":_vm.states,"results":_vm.results,"checkPayPalResult":_vm.checkPayPalResult,"fromPolandToEu":_vm.fromPolandToEu,"fromPoland":_vm.fromPoland},on:{"shippingCostCalculate":_vm.shippingCostCalculate}})
}
var staticRenderFns = []

export { render, staticRenderFns }